import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "otpInput",
    "backupKey",
    "emailKey",
    "backupKeyBtn",
    "sendBtn",
    "resendBtn",
    "otpBtn",
    "timer"
  ];

  #locked = false;

  connect() {
    this.useApp();
  }

  useApp() {
    if(this.hasOtpInputTarget) this.#showInput(this.otpInputTarget);
    if(this.hasBackupKeyTarget) this.#hideInput(this.backupKeyTarget);
    if(this.hasEmailKeyTarget) this.#hideInput(this.emailKeyTarget);
    
    if(this.hasOtpBtnTarget) this.#hide(this.otpBtnTarget);
    if(this.hasBackupKeyBtnTarget) this.#show(this.backupKeyBtnTarget);
    if(this.hasSendBtnTarget) this.#show(this.sendBtnTarget);
    if(this.hasResendBtnTarget) this.#hide(this.resendBtnTarget);

    if(this.hasOtpInputTarget) this.otpInputTarget.focus();
  }

  useBackupKey() {
    if(this.hasOtpInputTarget) this.#hideInput(this.otpInputTarget);
    if(this.hasBackupKeyTarget) this.#showInput(this.backupKeyTarget);
    if(this.hasEmailKeyTarget) this.#hideInput(this.emailKeyTarget);
    
    if(this.hasOtpBtnTarget) this.#show(this.otpBtnTarget);
    if(this.hasBackupKeyBtnTarget) this.#hide(this.backupKeyBtnTarget);
    if(this.hasSendBtnTarget) this.#show(this.sendBtnTarget);
    if(this.hasResendBtnTarget) this.#hide(this.resendBtnTarget);

    if(this.hasBackupKeyTarget) this.backupKeyTarget.focus();
  }

  sendEmailKey() {
    if(this.hasOtpInputTarget) this.#hideInput(this.otpInputTarget);
    if(this.hasEmailKeyTarget) this.#showInput(this.emailKeyTarget);
    if(this.hasBackupKeyTarget) this.#hideInput(this.backupKeyTarget);
    
    if(this.hasOtpBtnTarget) this.#show(this.otpBtnTarget);
    if(this.hasBackupKeyBtnTarget) this.#show(this.backupKeyBtnTarget);
    if(this.hasSendBtnTarget) this.#hide(this.sendBtnTarget);
    if(this.hasResendBtnTarget) this.#show(this.resendBtnTarget);

    if(this.hasBackupKeyTarget) this.backupKeyTarget.focus();

    if(this.hasTimerTarget) this.#startTimer();
  }

  #startTimer() {
    if(!this.#locked) {
      this.#locked = true;
      let timeout = 60;
      this.timerTarget.textContent = `(${timeout})`;
      this.resendBtnTarget.setAttribute("disabled", "disabled");
      this.resendBtnTarget.classList.add("disabled");
      this.resendBtnTarget.classList.add("text-gray");

      const interval = setInterval(() => {
        timeout--;
        if(timeout >= 0) {
          this.timerTarget.textContent = `(${timeout})`;
        } else {
          clearInterval(interval);
          this.timerTarget.textContent = '';
          this.#locked = false;
          this.resendBtnTarget.removeAttribute("disabled");
          this.resendBtnTarget.classList.remove("disabled");
          this.resendBtnTarget.classList.remove("text-gray");
        }
      }, 1000);
    }
  }

  #showInput(el) {
    el.parentElement.classList.remove("hide");
    el.removeAttribute("disabled");
  }

  #hideInput(el) {
    el.parentElement.classList.add("hide");
    el.setAttribute("disabled", "disabled");
  }

  #show(el) {
    el.classList.remove("hide");
  }

  #hide(el) {
    el.classList.add("hide");
  }
}